import React, { useState, useEffect } from "react";
import { useAuth } from "../context/UserContext";
import toast from "react-hot-toast";
import { EditProfile } from "../apis/Api";

const MyProfile = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    cust_token: "",
    f_name: "",
    l_name: "",
    cust_email: "",
    cust_alt_contact: "",
  });

  useEffect(() => {
    if (user && user.length > 0) {
      setFormData({
        cust_token: localStorage.getItem("token"),
        f_name: user[0].f_name || "",
        l_name: user[0].l_name || "",
        cust_email: user[0].cust_email || "",
        cust_alt_contact: user[0].cust_alt_contact || "",
      });
    }
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    console.log(formData);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await EditProfile(formData);
      console.log(response);
      if (response.status == 200) {
        toast.success("Profile updated successfully!");
      } else {
        throw new Error(response.message || "Something went wrong");
      }
    } catch (error) {
      toast.error(error.response?.message || "Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="col-md-5">
        <h2 className="fw-bold">My Profile</h2>
        <div
          className="card text-white p-3 mb-3 shadow-sm"
          style={{ backgroundColor: "#73b734", borderRadius: "10px" }}
        >
          <h4 className="mb-1 text-capitalize ">
            {formData.f_name} {formData.l_name}
          </h4>
          <div className="d-flex justify-content-between">
            <p className="mb-1">{user && user[0]?.cust_contact}</p>
            <p className="mb-1">{formData.cust_email}</p>
          </div>
          <button
            style={{ height: "30px" }}
            data-bs-toggle="modal"
            data-bs-target="#editProfileModal"
            className="btn btn-link text-white p-0"
          >
            Edit Profile →
          </button>
        </div>
      </div>

      {/* Edit Profile Modal */}
      <div
        className="modal fade"
        id="editProfileModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-3">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="fw-bold" style={{ color: "#73b734" }}>
                Edit Profile
              </h5>
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="f_name"
                    value={formData.f_name}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="l_name"
                    value={formData.l_name}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                name="cust_email"
                value={formData.cust_email}
                onChange={handleInputChange}
              
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Alternate Mobile Number</label>
              <input
                type="text"
                className="form-control"
                name="cust_alt_contact"
                value={formData.cust_alt_contact}
                onChange={handleInputChange}
              />
            </div>

            <button
              className="btn w-100 text-white"
              style={{ backgroundColor: "#73b734", height: "35px" }}
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyProfile;
